/**
 * Tile类
 * 表示单个方块
 */

import type { Position, TileValue } from './types';

let tileIdCounter = 0;

export class Tile {
  /** 唯一标识符 */
  public readonly id: number;
  /** 当前位置 */
  public position: Position;
  /** 方块数值 */
  public value: TileValue;
  /** 上一个位置（用于动画） */
  public previousPosition?: Position;
  /** 合并来源（用于动画） */
  public mergedFrom?: Tile[];

  /**
   * 构造函数
   * @param position 初始位置
   * @param value 方块数值
   */
  constructor(position: Position, value: TileValue) {
    this.id = tileIdCounter++;
    this.position = { ...position };
    this.value = value;
  }

  /**
   * 更新位置
   * @param position 新位置
   */
  public updatePosition(position: Position): void {
    this.previousPosition = { ...this.position };
    this.position = { ...position };
  }

  /**
   * 保存当前位置为上一个位置
   */
  public savePosition(): void {
    this.previousPosition = { ...this.position };
  }

  /**
   * 序列化为JSON对象（用于存储）
   * @returns 序列化后的对象
   */
  public serialize(): { position: Position; value: TileValue } {
    return {
      position: { ...this.position },
      value: this.value,
    };
  }

  /**
   * 从序列化数据创建Tile实例
   * @param data 序列化数据
   * @returns Tile实例
   */
  public static deserialize(data: { position: Position; value: TileValue }): Tile {
    return new Tile(data.position, data.value);
  }
}
